module.exports = new __parcel__URL__("jpd-prioritization-idea.70909cc6.svg").toString();